import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import MKBox from "components/MKBox";
import routes from "routes";
import bgImage from "assets/images/bg-presentation.jpg";

function Aprobado() {
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="365px"
        width="100%"
        sx={{
          position: "relative",
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0.5,
          },
        }}
      >
        <Container sx={{ position: "relative", zIndex: 2 }}>
          <Grid container item xs={12} lg={12} justifyContent="center" mx="auto" textAlign="center">
            <br />
          </Grid>
        </Container>
      </MKBox>

      <Container sx={{ mt: 4 }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={8} md={6}>
            <Card
              sx={{
                backgroundColor: "#e8f5e9",
                color: "#2e7d32",
                textAlign: "center",
                padding: "20px",
                boxShadow: 3,
              }}
            >
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "#2e7d32" }} />
                  <Typography variant="h5" fontWeight="bold" sx={{ mt: 2 }}>
                    ¡Pago aprobado!
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    Su pago ha sido procesado exitosamente.
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Aprobado;
